var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 24.0005H19V18.9575C18.9992 18.1735 18.6874 17.4218 18.133 16.8675C17.5787 16.3131 16.827 16.0013 16.043 16.0005H7.957C7.173 16.0013 6.42134 16.3131 5.86696 16.8675C5.31259 17.4218 5.00079 18.1735 5 18.9575V24.0005H3V18.9575C3.00159 17.6433 3.52435 16.3834 4.45363 15.4541C5.3829 14.5248 6.64281 14.0021 7.957 14.0005H16.043C17.3572 14.0021 18.6171 14.5248 19.5464 15.4541C20.4756 16.3834 20.9984 17.6433 21 18.9575V24.0005Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9999C10.8133 11.9999 9.65328 11.648 8.66658 10.9887C7.67989 10.3294 6.91085 9.39234 6.45673 8.29598C6.0026 7.19962 5.88378 5.99323 6.11529 4.82934C6.3468 3.66545 6.91825 2.59636 7.75736 1.75724C8.59648 0.918125 9.66558 0.34668 10.8295 0.115169C11.9933 -0.116342 13.1997 0.00247765 14.2961 0.456603C15.3925 0.910729 16.3295 1.67976 16.9888 2.66646C17.6481 3.65315 18 4.81319 18 5.99988C17.9984 7.59069 17.3658 9.11589 16.2409 10.2408C15.116 11.3656 13.5908 11.9983 12 11.9999V11.9999ZM12 1.99988C11.2089 1.99988 10.4355 2.23448 9.77772 2.674C9.11993 3.11353 8.60724 3.73824 8.30448 4.46915C8.00173 5.20005 7.92252 6.00432 8.07686 6.78024C8.2312 7.55617 8.61217 8.2689 9.17158 8.82831C9.73099 9.38772 10.4437 9.76868 11.2196 9.92302C11.9956 10.0774 12.7998 9.99815 13.5307 9.6954C14.2616 9.39265 14.8864 8.87996 15.3259 8.22216C15.7654 7.56436 16 6.79101 16 5.99988C16 4.93901 15.5786 3.9216 14.8284 3.17145C14.0783 2.42131 13.0609 1.99988 12 1.99988Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountData);
export default __webpack_public_path__ + "static/media/accountData.069c15c9bfa24641df298ff1e2193d32.svg";
export { ForwardRef as ReactComponent };